<template>
	<div class="page f fy p-2">

		<div class="main2 bg-white p-2">

			<div class="relative text-center f20 bolder">
				请登录
			</div>


			<el-form>
				<el-form-item label="账号">
					<el-input v-model="username"></el-input>
				</el-form-item>
				<el-form-item label="密码">
					<el-input v-model="password" type="password"></el-input>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" class="block w-full" @click="passwordLogin">登录</el-button>
				</el-form-item>
			</el-form>


		</div>


	</div>
</template>

<script>
	/*
	mode update 修改密码
	*/

	const UUID = {
		cs: '012346789abcdef'.toUpperCase().split(''),
		get: function(n) {
			n = n || 32;
			var value = "";
			for (var i = 0; i < n; i++) {
				var index = Math.floor(Math.random() * this.cs.length);
				value += this.cs[index];
			}
			return value;
		}
	};





	import mixin from '@/utils/mixin';
	export default {
		mixins: [mixin],
		components: {},
		data() {
			return {
				keyCode: '',
				deviceCode: '',
				// mode: 'login',
				code: '',
				time: 0,
				username: '',
				password: '',
				password2: '',
				errors: {
					username: '',
					password: '',
					password2: '',
				},
			}
		},
		onLoad() {
			this.deviceCode = uni.getStorageSync('deviceCode') || '';
		},
		methods: {

			// 密码登录
			passwordLogin() {
				if (!this.username) {
					this.showMessage('请输入用户名')
					return;
				}
				if (!this.password) {
					this.showMessage('请输入密码')
					return;
				}
				this.login({
					mode: 'PASSWORD',
					username: this.username,
					password: this.password,
				})

			},

			yjLogin() {
				this.login({
					mode: 'DEVICE_CODE',
					deviceCode: this.deviceCode,
				})
			},

			jhmLogin() {
				this.login({
					mode: 'KEY_CODE',
					keyCode: this.keyCode,
				})
			},

			login(data) {

				request({
					url: '/api/login/login',
					loading: true,
					data,
					success: resp => {
						this.setLogin(resp.data)
						this.success()
					}
				})

			},

			register() {
				if (!this.username) {
					this.showMessage('请输入用户名')
					return;
				}
				if (!this.password) {
					this.showMessage('请输入密码')
					return;
				}
				if (!this.password2) {
					this.showMessage('请输入密码')
					return;
				}
				if (this.password != this.password2) {
					this.showMessage('两次密码输入不一致')
					return;
				}
				this.$refs.imageCodeDialog.open({
					username: this.username,
					success: ({
						code
					}) => {
						request({
							url: '/api/login/register',
							loading: true,
							data: {
								code,
								username: this.username,
								password: this.password,
							},
							success: resp => {
								this.setLogin(resp.data)
								this.success()
							}
						})
					}
				})
			},


			success() {

				this.reTo('/');

				this.initLogin({});


			}



		},
		onUnload() {
			clearInterval(this.timer)
		}
	}
</script>

<style>

</style>